module.exports = __webpack_public_path__ + "img/725.417bddad.png";